module.exports = __webpack_public_path__ + "img/hr-puberty-decal-29.a6118a1e.png";